import { createRouter, createWebHashHistory } from 'vue-router'


const routes = [
  // {
  //   path: '/',
  //   name: 'Layout',
  //   component: () => import( '../views/Layout/index.vue')
  // },
  {
    path: '/',
    name: 'Layout',
    component: () => import('/src/layouts/BasicLayout')
  },{
    path: '/Login',
    name: 'Login',
    component: () => import('/src/views/userLoginReg/Login')
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})
// 路由守卫
// router.beforeEach((to, from, next) => {
// 	//console.log(1111)
//   // const isLogin = localStorage.getItem('locale') || 'zh';
//   // if (to.path == '/Login') {
//   //   next();
//   // } else {
//   //   // 是否在登录状态下
//   //   isLogin ? next() : next('/Login');
//   // }
// });

export default router
